<template>
  <b-card
    title="مدیریت کاربران"
  >
    <b-row>
      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                v-b-toggle.userbodyhistorycalculate
                variant="primary"
                class="mb-1 mr-auto ml-1"
              >
                محاسبه کالری
              </b-button>

              <b-col md="2">
                <b-form-group
                  label="شناسه"
                  label-for="Id"
                >
                  <b-form-input
                    v-model="filterOptions.Id"
                    autocomplete="off"
                    type="number"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group
                  label="نام و نام خانوادگی"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    autocomplete="off"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group
                  label="موبایل"
                  label-for="Mobile"
                >
                  <b-form-input
                    v-model="filterOptions.Mobile"
                    autocomplete="off"
                    type="number"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group
                  label="ایمیل"
                  label-for="Email"
                >
                  <b-form-input
                    v-model="filterOptions.Email"
                    autocomplete="off"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>

              <template v-if="collapse === false">
                <b-col md="2">
                  <b-form-group
                      label="نقش"
                      label-for="Role"
                  >
                    <user-role
                        v-model="filterOptions.RoleId"
                        :multiple="false"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group
                    label="جنسیت"
                    label-for="Gender"
                  >
                    <v-select
                      v-model="filterOptions.Gender"
                      dir="rtl"
                      :reduce="x => x.value"
                      label="text"
                      input-id="Gender"
                      :clearable="true"
                      :options="enums('Gender')"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                    label="از وزن"
                    label-for="FromWeight"
                  >
                    <b-form-input
                      v-model="filterOptions.FromWeight"
                      autocomplete="off"
                      type="number"
                      @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                    label="تا وزن"
                    label-for="ToWeight"
                  >
                    <b-form-input
                      v-model="filterOptions.ToWeight"
                      autocomplete="off"
                      type="number"
                      @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                    label="از قد"
                    label-for="FromHeight"
                  >
                    <b-form-input
                      v-model="filterOptions.FromHeight"
                      autocomplete="off"
                      type="number"
                      @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                    label="تا قد"
                    label-for="ToHeight"
                  >
                    <b-form-input
                      v-model="filterOptions.ToHeight"
                      autocomplete="off"
                      type="number"
                      @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                    label="از سن"
                    label-for="FromAge"
                  >
                    <b-form-input
                      v-model="filterOptions.FromAge"
                      autocomplete="off"
                      type="number"
                      @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                    label="تا سن"
                    label-for="ToAge"
                  >
                    <b-form-input
                      v-model="filterOptions.ToAge"
                      autocomplete="off"
                      type="number"
                      @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                    label="وضعیت"
                    label-for="IsActive"
                  >
                    <v-select
                      v-model="filterOptions.IsActive"
                      :options="enums('IsActive')"
                      dir="rtl"
                      label="text"
                      :reduce="x => x.value"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                    label="از تاریخ"
                    label-for="FromDate"
                  >
                    <date-picker
                      v-model="filterOptions.FromDate"
                      placeholder=""
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                    label="تا تاریخ"
                    label-for="FromDate"
                  >
                    <date-picker
                      v-model="filterOptions.ToDate"
                      placeholder=""
                    />
                  </b-form-group>
                </b-col>

              </template>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-secondary"
                class="btn-icon mb-1 mr-1"
                style="border: 1px solid #d8d6de !important;"
                @click="collapseFilter"
              >
                <feather-icon
                  :icon="collapseClass"
                />
              </b-button>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>

            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :sort-by="filterOptions.SortBy"
          :sort-desc="filterOptions.IsDesc"
          :busy="loading"
          :no-local-sorting="true"
          @sort-changed="sortChange"
        >
          <template #cell(Id)="data">
            <b-link
              :to="{ name: 'userDetail', params: { id: data.value }}"
              class="font-weight-bold"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(role)="data">
            <b-badge
              v-if="data.item.UserRole.Title"
              variant="primary"
            >
              {{ data.item.UserRole.Title }}
            </b-badge>
          </template>

          <template #cell(CreatedAt)="data">
            {{ data.value | date }}
          </template>

          <template #cell(IsActive)="data">
            <b-badge
              :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(Name)="data">
            <span class="text-nowrap">
              <b-avatar
                class="mr-1"
                :src="data.item.Image"
              />
              {{ data.item.Name }} {{ data.item.Family }}
            </span>
          </template>

          <template #cell(actions)="data">
            <div
              class="text-nowrap"
            >
              <b-link :to="{ name: 'userDetail', params: { id: data.item.Id }}">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <z-user-body-history-calculate />
  </b-card>
</template>

<script>

import ZUserBodyHistoryCalculate from '@/views/menu/user/userbodyhistorycalculate.vue'
import { VBToggle } from 'bootstrap-vue'
import userRole from '@/tools/userrole.vue'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    ZUserBodyHistoryCalculate,
    userRole
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      collapse: true,
      collapseClass: 'ChevronLeftIcon',
      filterOptions: {
        Title: null,
        Page: 1,
        IsActive: null,
        SortBy: 'Id',
        IsDesc: true,
        Mobile: null,
        Email: null,
        Id: null,
        Language: null,
        Gender: null,
        FromDate: null,
        ToDate: null,
        FromWeight: null,
        ToWeight: null,
        FromHeight: null,
        ToHeight: null,
        FromAge: null,
        ToAge: null,
        RoleId: null
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },

        {
          key: 'Name',
          label: 'نام و نام خانوادگی',
          sortable: true,
        },
        {
          key: 'Mobile',
          label: 'موبایل',
        },
        {
          key: 'Email',
          label: 'ایمیل',
        },
        {
          key: 'Role',
          label: 'نقش',
        },
        {
          key: 'CreatedAt',
          label: 'تاریخ',
          sortable: true,
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.user.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(id) {
      this.removeRow(this.$api.user.remove, 'Id', id)
    },
    collapseFilter() {
      this.collapse = !this.collapse
      if (this.collapse) {
        this.collapseClass = 'ChevronLeftIcon'
      } else {
        this.collapseClass = 'ChevronRightIcon'
      }
    },
  },
}
</script>
